'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.createBreadcrumbSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Constants


// Actions


// Utils

// Drop Utils


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = require('reselect');

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _elementConstants = require('../../../../common/elements/elementConstants');

var _navigationActions = require('../../../reducers/navigationActions');

var _popupActions = require('../../../components/popupPanel/popupActions');

var _currentUserActions = require('../../../user/currentUserActions');

var _permissionsService = require('../../../utils/permissions/permissionsService');

var _permissionUtil = require('../../../../common/permissions/permissionUtil');

var _tooltipUtil = require('../../../components/popupPanel/tooltips/tooltipUtil');

var tooltipUtil = _interopRequireWildcard(_tooltipUtil);

var _tooltipConstants = require('../../../components/popupPanel/tooltips/tooltipConstants');

var _makeCanDropFn = require('../../../element/dnd/canDrop/makeCanDropFn');

var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);

var _preventLinePredicate = require('../../../element/dnd/canDrop/preventLinePredicate');

var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);

var _preventDropOnCurrentBoardPredicate = require('../../../element/dnd/canDrop/preventDropOnCurrentBoardPredicate');

var _preventDropOnCurrentBoardPredicate2 = _interopRequireDefault(_preventDropOnCurrentBoardPredicate);

var _hasCanDropPredicate = require('../../../element/dnd/canDrop/hasCanDropPredicate');

var _hasCanDropPredicate2 = _interopRequireDefault(_hasCanDropPredicate);

var _inboxDropLocationFn = require('../../../inbox/inboxDropLocationFn');

var _inboxDropLocationFn2 = _interopRequireDefault(_inboxDropLocationFn);

var _navigateOnHoverDecorator = require('../../../element/dnd/navigateOnHoverDecorator');

var _navigateOnHoverDecorator2 = _interopRequireDefault(_navigateOnHoverDecorator);

var _ElementDropTarget = require('../../../element/dnd/ElementDropTarget');

var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);

var _BreadcrumbIcon = require('./BreadcrumbIcon');

var _BreadcrumbIcon2 = _interopRequireDefault(_BreadcrumbIcon);

var _PopupPanel = require('../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

require('./Breadcrumb.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BreadcrumbTitle = function BreadcrumbTitle(_ref) {
    var element = _ref.element;
    return _react2.default.createElement(
        'div',
        { className: 'breadcrumb-title' },
        element && element.getIn(['content', 'title'])
    );
};

BreadcrumbTitle.propTypes = {
    element: _propTypes2.default.object
};

var createBreadcrumbSelector = exports.createBreadcrumbSelector = function createBreadcrumbSelector() {
    return (0, _reselect.createSelector)(function (state) {
        return state.get('elements');
    }, function (state, props) {
        return props.elementId;
    }, function (state, props) {
        return state.getIn(['app', 'currentUser', 'rootBoardId']);
    }, function (state, props) {
        return state.getIn(['app', 'currentUser']);
    }, function (state, props) {
        return props.currentBoardId;
    }, (0, _permissionsService.createElementUserPermissionsSelector)(), _permissionsService.currentBoardUserPermissionsSelector, function (elements, elementId, rootBoardId, currentUser, currentBoardId, breadcrumbPermissions, currentBoardPermissions) {
        var canDrop = (0, _permissionUtil.canWrite)(breadcrumbPermissions) && (0, _permissionUtil.canWrite)(currentBoardPermissions) && (0, _permissionUtil.canSave)(breadcrumbPermissions) === (0, _permissionUtil.canSave)(currentBoardPermissions);

        return {
            element: elements.get(elementId),
            isRoot: elementId === rootBoardId,
            canDrop: canDrop,
            isCurrentBoard: elementId === currentBoardId,
            currentUser: currentUser,
            // This supports the hover navigate functionality
            dropPermitted: canDrop
        };
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchNavigateToBoard: function dispatchNavigateToBoard(boardId, keepSelection) {
            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId, keepSelection: keepSelection }));
        },
        showTooltip: function showTooltip() {
            return dispatch((0, _popupActions.openPopup)('tooltip-breadcrumb'));
        },
        updateUser: function updateUser(action) {
            return dispatch((0, _currentUserActions.updateCurrentUser)(action));
        }
    };
};

var dropTargetConfig = {
    drop: _inboxDropLocationFn2.default,
    canDrop: (0, _makeCanDropFn2.default)([_hasCanDropPredicate2.default, _preventDropOnCurrentBoardPredicate2.default, _preventLinePredicate2.default])
};

var Breadcrumb = (_dec = (0, _reactRedux.connect)(createBreadcrumbSelector, mapDispatchToProps), _dec2 = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.BREADCRUMB), _dec(_class = _dec2(_class = (0, _navigateOnHoverDecorator2.default)(_class = function (_React$Component) {
    _inherits(Breadcrumb, _React$Component);

    function Breadcrumb() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, Breadcrumb);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call.apply(_ref2, [this].concat(args))), _this), _this.navigateToBoard = function (event) {
            var _this$props = _this.props,
                currentBoardId = _this$props.currentBoardId,
                elementId = _this$props.elementId,
                dispatchNavigateToBoard = _this$props.dispatchNavigateToBoard;


            event.preventDefault();

            if (currentBoardId === elementId) return;

            dispatchNavigateToBoard(elementId);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Breadcrumb, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                index = _props.index,
                showTooltip = _props.showTooltip,
                isCurrentBoard = _props.isCurrentBoard,
                currentUser = _props.currentUser,
                updateUser = _props.updateUser;


            if (index === 0 && isCurrentBoard && !nextProps.isCurrentBoard && !tooltipUtil.hasSeen(currentUser.get('education'), _tooltipConstants.TOOLTIP_CODES.BREADCRUMB)) {
                showTooltip();

                updateUser({
                    userId: currentUser.get('_id'),
                    changes: {
                        education: tooltipUtil.markAsSeen(currentUser.get('education'), _tooltipConstants.TOOLTIP_CODES.BREADCRUMB)
                    }
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                elementId = _props2.elementId,
                connectDropTarget = _props2.connectDropTarget,
                canDrop = _props2.canDrop,
                isHovered = _props2.isHovered,
                isCurrentBoard = _props2.isCurrentBoard,
                index = _props2.index,
                showNavigationFeedback = _props2.showNavigationFeedback;


            var linkURL = '/' + elementId;

            var classes = (0, _classnames2.default)('Breadcrumb', {
                'can-drop': canDrop,
                hovered: isHovered,
                current: isCurrentBoard,
                'pre-nav': showNavigationFeedback
            });

            if (isCurrentBoard) {
                return _react2.default.createElement(
                    'li',
                    { className: classes },
                    _react2.default.createElement(
                        'div',
                        { className: 'BreadcrumbContents' },
                        _react2.default.createElement(_BreadcrumbIcon2.default, this.props),
                        _react2.default.createElement(BreadcrumbTitle, this.props)
                    )
                );
            }

            var popup = void 0;
            if (index === 0) {
                popup = _react2.default.createElement(
                    _PopupPanel2.default,
                    { className: 'tooltip',
                        popupId: 'tooltip-breadcrumb',
                        arrowDir: 'top',
                        fadeIn: true },
                    _react2.default.createElement(
                        'span',
                        null,
                        'Click to go back'
                    )
                );
            }

            return connectDropTarget(_react2.default.createElement(
                'li',
                { className: classes },
                _react2.default.createElement(
                    'a',
                    { className: 'BreadcrumbContents', href: linkURL, onClick: this.navigateToBoard },
                    _react2.default.createElement(_BreadcrumbIcon2.default, this.props),
                    _react2.default.createElement(BreadcrumbTitle, this.props),
                    popup
                )
            ));
        }
    }]);

    return Breadcrumb;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = Breadcrumb;


Breadcrumb.propTypes = {
    elementId: _propTypes2.default.string.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired,
    element: _propTypes2.default.object,
    dispatchNavigateToBoard: _propTypes2.default.func,
    connectDropTarget: _propTypes2.default.func,
    canDrop: _propTypes2.default.bool,
    isCurrentBoard: _propTypes2.default.bool,
    isHovered: _propTypes2.default.bool,
    isRoot: _propTypes2.default.bool,
    showTooltip: _propTypes2.default.func,
    index: _propTypes2.default.number,
    currentUser: _propTypes2.default.object,
    updateUser: _propTypes2.default.func,
    showNavigationFeedback: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/breadcrumbs/Breadcrumb.js
// module id = 2162
// module chunks = 0